const StationNetworkTypeEnum = {
  1: 'Cable',
  2: 'Station',
  3: 'Radio',
};

export default StationNetworkTypeEnum;